import React from "react"

import { graphql } from "gatsby"
import PropTypes from "prop-types"

import CopyContainer from "../components/atoms/copy-container"
import Grid from "../components/atoms/grid"
import Heading from "../components/atoms/heading"
import Illustration from "../components/atoms/illustration"
import Title from "../components/atoms/title"
import Wrapper from "../components/atoms/wrapper"
import Seo from "../components/head"
import Layout from "../components/layout"
import Card from "../components/molecules/card"
import Feed from "../components/organisms/feed"

const NewsletterPage = ({ data, pageContext }) => {
  const allNewsletters = data.allSanityArchive.nodes
    .concat(data.allSanityCampaign.nodes)
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .map((newsletter) => {
      const firstArticle = newsletter.content?.find(
        (section) => section.article && !section.article.partner
      )?.article
      return {
        ...newsletter,
        url: `/newsletter/${newsletter.vertical.slug.current}/${newsletter.id}`,
        storyType: newsletter.vertical.name,
        abstract: newsletter.subject?.preview_text,
        image: firstArticle?.featured_image.image,
        title:
          newsletter._type === "archive"
            ? `${newsletter.vertical.name}
        ${
          data.allSanityDictionary.nodes.find(
            (item) => item.key.current === "newsletter"
          )?.value
        }`
            : newsletter.subject?.subject_line,
      }
    })
  return (
    <Layout>
      <Title color="sky">
        <Heading center>
          {
            data.allSanityDictionary.nodes.find(
              (item) => item.key.current === "newsletters_title"
            )?.value
          }{" "}
          <Illustration
            icon={
              data.allSanityIcon.nodes.find((illustration) =>
                illustration.name.toLowerCase().includes("laptop with eyes")
              )?.image
            }
          />
        </Heading>
        <CopyContainer alignment="centered">
          {
            data.allSanityDictionary.nodes.find(
              (item) => item.key.current === "newsletters_description"
            )?.value
          }
        </CopyContainer>
      </Title>
      {!pageContext.prevPage ? (
        <Wrapper container>
          <Grid col={data.allSanityVertical.nodes.length}>
            {data.allSanityVertical.nodes.map((vertical) => (
              <div>
                <Card
                  variant="secondary_feature"
                  color={vertical.color}
                  article={{
                    ...vertical,
                    url: `/newsletter/${vertical.slug.current}/latest`,
                  }}
                />
              </div>
            ))}
          </Grid>
        </Wrapper>
      ) : (
        ""
      )}
      <Feed
        stories={allNewsletters}
        prevPage={pageContext.prevPage}
        nextPage={pageContext.nextPage}
        basic
      />
    </Layout>
  )
}

NewsletterPage.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
}

export default NewsletterPage

const HeadComponent = ({ data, pageContext, location }) => (
  <Seo
    title={
      data.allSanityDictionary.nodes.find(
        (item) => item.key.current === "newsletters_title"
      )?.value
    }
    path={location.pathname}
    prevPage={pageContext.prevPage}
    nextPage={pageContext.prevPage}
  />
)

HeadComponent.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
}

export const Head = HeadComponent

export const pageQuery = graphql`
  query newslettersQuery($newsletters: [String]!) {
    allSanityDictionary {
      nodes {
        key {
          current
        }
        value
      }
    }
    allSanityIcon {
      nodes {
        name
        image {
          ...ImageWithPreview
        }
      }
    }
    allSanityVertical(
      sort: { _createdAt: DESC }
      filter: { archive: { ne: true } }
    ) {
      nodes {
        title: name
        color
        slug {
          current
        }
      }
    }
    allSanityCampaign(filter: { _id: { in: $newsletters } }) {
      nodes {
        id: _id
        _type
        subject {
          subject_line
          preview_text
        }
        content {
          ... on SanityCampaignArticle {
            article {
              partner {
                name
              }
              featured_image {
                image {
                  ...ImageWithPreview
                }
              }
            }
          }
        }
        date
        vertical {
          name
          color
          slug {
            current
          }
        }
      }
    }
    allSanityArchive(filter: { _id: { in: $newsletters } }) {
      nodes {
        id: _id
        _type
        date
        vertical {
          name
          color
          slug {
            current
          }
        }
      }
    }
  }
`
